import { render, staticRenderFns } from "./ServiceContactInfo.vue?vue&type=template&id=5ad3f2fb&scoped=true"
import script from "./ServiceContactInfo.vue?vue&type=script&lang=ts"
export * from "./ServiceContactInfo.vue?vue&type=script&lang=ts"
import style0 from "./ServiceContactInfo.vue?vue&type=style&index=0&id=5ad3f2fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad3f2fb",
  null
  
)

export default component.exports